import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { Layout } from './components/Layout';
import { AdminLayout } from './components/AdminLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Training } from './pages/Training';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { OrganizationsList } from './pages/admin/OrganizationsList';
import { OrganizationDetails } from './pages/admin/OrganizationDetails';
import { AccessCodesList } from './pages/admin/AccessCodesList';
import { AdminsList } from './pages/admin/AdminsList';
import { GlobalSettings } from './pages/admin/GlobalSettings';
import './App.css';

function App(): JSX.Element {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected user routes */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/training/:slug" element={<Training />} />
          </Route>

          {/* Admin routes */}
          <Route
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/organizations" element={<OrganizationsList />} />
            <Route path="/admin/organizations/:id" element={<OrganizationDetails />} />
            <Route path="/admin/access-codes" element={<AccessCodesList />} />
            <Route path="/admin/settings" element={<GlobalSettings />} />

            {/* Super-Admin only routes */}
            <Route
              path="/admin/admins"
              element={
                <AdminRoute requireSuperAdmin>
                  <AdminsList />
                </AdminRoute>
              }
            />
          </Route>

          {/* Redirects */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
